module.exports = __webpack_public_path__ + "static/media/PSX.4cdadc7c.svg";